// extracted by mini-css-extract-plugin
export default {"features":"features_features__k0ZfU","slick-dots":"features_slick-dots__DM+3n"};